import type { StakeError } from '../types';

export const isStakeError = (error: unknown): error is StakeError =>
  typeof error === 'object' && !!error && 'translationTag' in error && 'value' in error;
